module.exports = __webpack_public_path__ + "resources/img/logo_toast_color_v2.950e5894754f55001d4316ee1a3fd1ff.svg";